export default [
  {
    id: '2344917a-3691-41b2-a795-17ac8461aace', // id 全局唯一，终身制
    path: '/wiz-tag-3d-position-management-tongre',
    name: 'wizTag3dPositionManagementTongre',
    meta: { title: '点位设置' },
    // layout: 'default',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: 'bacd540e-a0d6-4d4c-ac25-0d78348bb60a', // id 全局唯一，终身制
        path: 'position-setting',
        name: 'positionSetting',
        meta: { title: '设备点位设置' },
        children: [
          {
            id: 'dbed462c-c146-43ac-b435-0bc0ffda8750',
            path: 'position-setting',
            name: 'positionSetting',
            component: () => {
              return import('./views/tag3dPosition/monitor-location-setting/index')
            },
            meta: {
              title: '点位设置',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '6663aa4a-4c9c-47b4-a40c-e37bbf0914f6',
            path: 'position-setting-vulkan',
            name: 'positionSettingVulkan',
            component: () => {
              return import('./views/tag3dPosition/position-setting-vulkan/index')
            },
            meta: {
              title: '点位设置',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
]
